
import { bestPicFormat } from '@/assets/scripts/utils'

export default {
  name: 'DrinkCardBeer',

  props: {
    data: { type: Object, default: () => ({}) },
  },

  computed: {
    pointlist() {
      let list = this.data.properties
        ? Object.keys(this.data.properties).filter(
            (k) => this.data.properties[k]
          )
        : []
      if (this.data.country && this.data.country !== '')
        list.unshift(this.data.country)
      if (list.length > 6) {
        list = list.slice(0, 5)
        list.push('...')
      }
      return list
    },
  },

  created() {
    this.bestPicFormat = bestPicFormat
  },
}
